import { IonContent, IonHeader, IonPage, useIonToast } from '@ionic/react';
import React from 'react';
import Toolbar from '../components/common/Toolbar';
import styled from 'styled-components';
import Logo from '../components/common/Logo';
import ContactForm from '../components/forms/ContactForm';
import { useFirebase } from '../services/firebase';
import Cookies from 'js-cookie';
import { checkmarkCircleOutline, warning } from 'ionicons/icons';
import { CONTACT_FORM_SUBMITTED } from '../util/cookie';
import { contactUs } from '../api/cloudFunctions';
import { getFunctions } from 'firebase/functions';

interface ContactProps {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 80px 0 42px 0;
  padding: 0 16px;
`;

const LogoContainer = styled.div`
  max-width: 400px;
`;

const Contact: React.FC<ContactProps> = (props) => {
  const { app, currentUser } = useFirebase();
  const [present] = useIonToast();
  return (
    <IonPage>
      <IonHeader>
        <Toolbar showBackButton showMenu />
      </IonHeader>
      <IonContent>
        <Container>
          <LogoContainer>
            <Logo />
          </LogoContainer>

          <ContactForm
            currentUser={currentUser}
            onSubmit={async (values) => {
              const now = new Date();
              // Check if the user has already submitted the form recently
              const lastSubmitted = Cookies.get(CONTACT_FORM_SUBMITTED);
              if (lastSubmitted) {
                const lastDate = new Date(lastSubmitted);
                const diff = now.getTime() - lastDate.getTime();
                const minutesSinceLastSubmission = Math.floor(diff / 1000 / 60);
                console.log(
                  `Last submission was ${minutesSinceLastSubmission} minutes ago`
                );
                // Cannot submit the form if it was submitted less than 30 minutes ago
                if (minutesSinceLastSubmission < 30) {
                  present({
                    message:
                      'You have already submitted this form recently. Please wait a while before submitting again.',
                    duration: 6000,
                    icon: warning,
                    color: 'warning',
                  });
                  throw new Error('Error');
                }
              }

              // Set cookie with current time
              const date = now.toISOString();
              Cookies.set(CONTACT_FORM_SUBMITTED, date, { expires: 7 });

              const fns = getFunctions(app);
              await contactUs(fns, values);
              console.log('Form submitted:', values);
              present({
                message: 'Message sent successfully',
                duration: 6000,
                icon: checkmarkCircleOutline,
              });
            }}
          />
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default Contact;
